// ── IMAGE SLOTS (Team Meeting Ready) ────────────────────────────────
// Hosted in the Impultienda store resources and ebook covers.
const STORE = 'f0df0607-92e2-4d1f-aa4b-4d01bfd0e5b1';
const RES = `https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/${STORE}/`;
const COVER = (id: string) =>
  `https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/render/image/public/ebook-images/${STORE}/${id}-mockup.webp?width=720&quality=85&resize=contain`;

/**
 * iMac + 3 tablets + 2 phones, one bonus per device. The iMac screen shows the REAL cover of the Gamma Studio book
 * (plus real pages 4 and 9), composited from the real images, no AI text. Pure white background: show it on bg-white.
 */
const IMAC = RES + '1792591588856_mockup-imac-tapa-studio-3fa17cec.webp';
export const heroMockupUrl = IMAC;
export const offerMockupUrl = IMAC;
/**
 * Real pages of the Gamma Studio book (9:16, dark theme), same order as lookInside.captions: p.4, 9, 10, 12, 36, 40.
 * Do not use p.8 (broken text on the whiteboard photo) or p.38 (made-up data in the index).
 */
export const pageImages: string[] = [
  RES + '1792591140412_studio-04-plan-q1-91b0cae0.webp',
  RES + '1792591145011_studio-09-actividad-c777f852.webp',
  RES + '1792591149630_studio-10-discuss-close-9d76d0c8.webp',
  RES + '1792591154453_studio-12-priority-grid-09e5ade1.webp',
  RES + '1792591159121_studio-36-look-back-ahead-b1d4268b.webp',
  RES + '1792591163681_studio-40-field-card-52e08b0b.webp',
];
/** 5 bonus covers, in the same order as bonuses (and as the checkout) */
export const bonusCovers: string[] = [
  COVER('393f2666-a6d8-44aa-823f-ef6e65d7cbb0'),
  COVER('fa4494dd-3692-4ff3-bba5-7711058f2f39'),
  COVER('0bfed792-15cc-4ff7-9ea1-eea2d8fd6406'),
  COVER('e5ce4c87-abc7-48ac-8f48-71e880acb37d'),
  COVER('1dfbb032-d40a-4ca5-86ef-b834522bc16f'),
];
